var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { staticClass: "padding_5px_top" },
        [
          _c(
            "el-tabs",
            {
              attrs: { id: "rankingTab" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "first" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("股票型 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "EqutityTab" },
                      model: {
                        value: _vm.activeNameEqutity,
                        callback: function ($$v) {
                          _vm.activeNameEqutity = $$v
                        },
                        expression: "activeNameEqutity",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "普通股票型", name: "first" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "香港股票型", name: "second" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "沪港深股票型", name: "third" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业股票–医药", name: "fourth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: {
                          label: "行业股票-科技、传媒及通讯",
                          name: "fifth",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业股票-消费", name: "sixth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业股票-金融地产", name: "seventh" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业股票 - 其它", name: "CHCA000047" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "second" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("混合型 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "AllocationTab" },
                      model: {
                        value: _vm.activeNameAllocation,
                        callback: function ($$v) {
                          _vm.activeNameAllocation = $$v
                        },
                        expression: "activeNameAllocation",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "积极配置型", name: "first" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "标准混合型", name: "second" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "保守混合型", name: "third" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "灵活配置型", name: "fourth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业混合-医药", name: "fifth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: {
                          label: "行业混合-科技、传媒及通讯",
                          name: "sixth",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "行业混合-消费", name: "seventh" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "沪港深积极配置型", name: "eighth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "沪港深保守混合型", name: "ninth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "沪港深灵活配置型", name: "tenth" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "目标日期", name: "eleventh" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "third" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("可转债 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "ConvertibleBondTab" },
                      model: {
                        value: _vm.activeNameConvertibleBond,
                        callback: function ($$v) {
                          _vm.activeNameConvertibleBond = $$v
                        },
                        expression: "activeNameConvertibleBond",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "可转债", name: "first" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fourth" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("债券型 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "BondTab" },
                      model: {
                        value: _vm.activeNameBond,
                        callback: function ($$v) {
                          _vm.activeNameBond = $$v
                        },
                        expression: "activeNameBond",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "积极债券型", name: "first" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "普通债券型", name: "second" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "纯债型", name: "third" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "利率债", name: "CHCA000048" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "信用债", name: "CHCA000049" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "短债型", name: "fourth" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fifth" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("货币型 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "MoneyMarketFundsTab" },
                      model: {
                        value: _vm.activeNameMoneyMarketFunds,
                        callback: function ($$v) {
                          _vm.activeNameMoneyMarketFunds = $$v
                        },
                        expression: "activeNameMoneyMarketFunds",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "货币市场", name: "first" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "", name: "sixth" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("另类 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "MarketNeutralTab" },
                      model: {
                        value: _vm.activeNameMarketNeutral,
                        callback: function ($$v) {
                          _vm.activeNameMarketNeutral = $$v
                        },
                        expression: "activeNameMarketNeutral",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "市场中性", name: "first" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "seventh" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("商品 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "CommoditiesTab" },
                      model: {
                        value: _vm.activeNameCommodities,
                        callback: function ($$v) {
                          _vm.activeNameCommodities = $$v
                        },
                        expression: "activeNameCommodities",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: " 商品-贵金属", name: "first" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", { attrs: { label: "|" } }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: " 商品-其它", name: "second" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "eighth" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("其它 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "OthersTab" },
                      model: {
                        value: _vm.activeNameOthers,
                        callback: function ($$v) {
                          _vm.activeNameOthers = $$v
                        },
                        expression: "activeNameOthers",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "其它", name: "first" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "tableSpecial",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "default-sort": { prop: "PriceDate", order: "descending" },
          },
          on: { "sort-change": _vm.sortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "custom",
              prop: "defaultSymbol",
              label: "基金代码",
              width: "110",
              "render-header": _vm.renderheaderRefreshData,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "custom",
              prop: "legalName",
              label: "基金名称",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "inceptionDate",
              label: "成立日期",
              "min-width": "120",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("replaceTime")(scope.row.inceptionDate))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "", align: "center" } },
            [
              _c("template", { slot: "header" }, [
                _c("span", [
                  _vm._v("晨星评级(" + _vm._s(_vm.ratingDate) + ")"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "starRating3",
                  label: "三年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating3)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating3)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating3)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating3),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticStyle: { "background-color": "red !important" },
                attrs: {
                  prop: "starRating5",
                  label: "五年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating5)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating5)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating5)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating5),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "starRating10",
                  label: "十年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating10)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating10)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating10)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating10),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "priceDate",
              label: "净值日期",
              "min-width": "120",
              sortable: "custom",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("replaceTime")(scope.row.priceDate))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nav",
              label: "单位净值|(元)",
              "min-width": "120",
              "render-header": _vm.renderheader2Row,
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("fillNullRound")(scope.row.nav, 4))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "returnYTD",
              label: "今年以来|总回报率",
              "min-width": "120",
              sortable: "custom",
              "render-header": _vm.renderheader2Row,
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("fillNullRound")(scope.row.returnYTD, 2))
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.returnYTD)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "return1Week",
              label: "最近一周|总回报率",
              "min-width": "120",
              align: "center",
              "render-header": _vm.renderheader2Row,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.return1Week, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.return1Week)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "return1Month",
              label: "最近一月|总回报率",
              "min-width": "120",
              align: "center",
              "render-header": _vm.renderheader2Row,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.return1Month, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.return1Month)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "return3Month",
              label: "最近三月|总回报率",
              "min-width": "120",
              align: "center",
              "render-header": _vm.renderheader2Row,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.return3Month, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.return3Month)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "return6Month",
              label: "最近六月|总回报率",
              "min-width": "120",
              align: "center",
              "render-header": _vm.renderheader2Row,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.return6Month, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.return6Month)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近一年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return1Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return1Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return1Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return1YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return1YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return1Year,
                            _vm.showNoRankingIcon,
                            scope.row.return1YearRankNavOutlier,
                            scope.row.return1YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return1Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return1YearRankNavOutlier,
                                            scope.row
                                              .return1YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近两年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return2Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return2Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return2Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn2Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn2Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn2Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return2YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return2YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return2Year,
                            _vm.showNoRankingIcon,
                            scope.row.return2YearRankNavOutlier,
                            scope.row.return2YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return2Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return2YearRankNavOutlier,
                                            scope.row
                                              .return2YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近三年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return3Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return3Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return3Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn3Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn3Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn3Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return3YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return3YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return3Year,
                            _vm.showNoRankingIcon,
                            scope.row.return3YearRankNavOutlier,
                            scope.row.return3YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return3Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return3YearRankNavOutlier,
                                            scope.row
                                              .return3YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近五年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return5Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return5Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return5Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn5Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn5Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn5Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return5YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return5YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return5Year,
                            _vm.showNoRankingIcon,
                            scope.row.return5YearRankNavOutlier,
                            scope.row.return5YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return5Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return5YearRankNavOutlier,
                                            scope.row
                                              .return5YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近七年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return7Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return7Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return7Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn7Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn7Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn7Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return7YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return7YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return7Year,
                            _vm.showNoRankingIcon,
                            scope.row.return7YearRankNavOutlier,
                            scope.row.return7YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return7Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return7YearRankNavOutlier,
                                            scope.row
                                              .return7YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近十年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return10Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return10Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return10Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn10Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn10Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn10Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return10YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return10YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return10Year,
                            _vm.showNoRankingIcon,
                            scope.row.return10YearRankNavOutlier,
                            scope.row.return10YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return10Year,
                                            _vm.showNoRankingIcon,
                                            scope.row
                                              .return10YearRankNavOutlier,
                                            scope.row
                                              .return10YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "最近十五年", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return15Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return15Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return15Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn15Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn15Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn15Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return15YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return15YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return15Year,
                            _vm.showNoRankingIcon,
                            scope.row.return15YearRankNavOutlier,
                            scope.row.return15YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return15Year,
                                            _vm.showNoRankingIcon,
                                            scope.row
                                              .return15YearRankNavOutlier,
                                            scope.row
                                              .return15YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "returnInception",
              label: "成立以来|总回报率",
              "min-width": "120",
              sortable: "custom",
              "render-header": _vm.renderheader2Row,
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.returnInception, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.returnInception)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "left_text_align padding_25px_top" },
        [
          (_vm.pagination.count > 10 ? true : false)
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.params.page,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pagination.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: (_vm.pagination && _vm.pagination.count) || 0,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }